import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { addNotification } from "@/redux/reducer/notificationSlice";

type NotifyType = "success" | "error" | "info";

export function useNotify() {
  const dispatch = useDispatch();

  return useCallback(
    (type: NotifyType, title: string, subtitle: string) => {
      dispatch(addNotification({ type, title, subtitle }));
    },
    [dispatch],
  );
}